import { render, staticRenderFns } from "./onboarding-details.vue?vue&type=template&id=29126003&scoped=true&"
import script from "./onboarding-details.vue?vue&type=script&lang=js&"
export * from "./onboarding-details.vue?vue&type=script&lang=js&"
import style0 from "./onboarding-details.vue?vue&type=style&index=0&id=29126003&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29126003",
  null
  
)

component.options.__file = "onboarding-details.vue"
export default component.exports